import { ThemeProvider } from "@mui/material/styles";
import { PlatformProvider } from "providers/Auth/platform.provider";
import { Redirect, Route, Switch } from "react-router-dom";
import { AvailableBaseRoutes } from "utils/constants";
import MuiTheme from "./config/theme";
import { Portal } from "./portal";
import { LoginAsProvider } from "./providers/Auth/login-as-context";
import { ValidationProvider } from "./providers/Validation/validation-context";
import { ScrollToTopProvider } from "./domain/scroll/scroll-to-top-context";
import { Login } from "./pages/login/login.page";

const Routes = () => {
  return (
    <ThemeProvider theme={MuiTheme}>
      <ValidationProvider>
        <ScrollToTopProvider>
          <LoginAsProvider>
            <PlatformProvider>
              <Switch>
                <Route path={AvailableBaseRoutes.Portal} component={Portal} />
                <Route path={["/", AvailableBaseRoutes.Login]} exact component={Login} />
                <Redirect path="*" to={AvailableBaseRoutes.Login} push />
              </Switch>
            </PlatformProvider>
          </LoginAsProvider>
        </ScrollToTopProvider>
      </ValidationProvider>
    </ThemeProvider>
  );
};

export default Routes;
